import React from 'react';
import { css } from 'aphrodite';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import styles from './styles';

export type FolderPickerRegularInfoBannerProps = {
  currentMatterName: string;
  projectName: string;
};

const FolderPickerRegularInfoBanner = ({
  currentMatterName,
  projectName,
}: FolderPickerRegularInfoBannerProps) => {
  return (
    <div className={css(styles.infoBanner)}>
      <div className={css(styles.infoBannerContent)}>
        <InfoOutlinedIcon className={css(styles.infoBannerIcon)} />
        <div>
          <div className={css(styles.infoBannerText)}>
            The following item(s) will be saved as a new file / folder within
            the <span>{currentMatterName}</span> folder
          </div>
          <div className={css(styles.infoBannerBulletList)}>
            <span className={css(styles.infoBannerBullet)}>•</span>
            <span>{projectName}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FolderPickerRegularInfoBanner;
